import React, { useEffect } from "react";
import { useController, useFormContext } from "react-hook-form";
import PropTypes from "prop-types";

import { PermissionDropdown } from "../../../AddUserModal/components/NewUserInfoPage/components";
import useGetRoles from "../../../hooks/useGetRoles";

export function ControlledPermissionDropdownForm({
  name,
  defaultValue,
  ...props
}) {
  const { setValue } = useFormContext();
  const {
    field,
    fieldState: { error },
  } = useController({ name, defaultValue });

  const { defaultRole, data, loading } = useGetRoles();

  useEffect(() => {
    if (!field.value && defaultRole?.id) setValue(name, defaultRole.id);
  }, [name, field.value, defaultRole, setValue]);

  return (
    <PermissionDropdown
      data-test="role-dropdown"
      disabled={loading}
      error={error}
      roleData={data}
      value={field.value || defaultRole?.id}
      onChangeCb={field.onChange}
      {...props}
    />
  );
}

ControlledPermissionDropdownForm.propTypes = {
  name: PropTypes.string.isRequired,
  defaultValue: PropTypes.string,
};

ControlledPermissionDropdownForm.defaultProps = {
  defaultValue: "",
};

export default ControlledPermissionDropdownForm;
